import Vue from 'vue';
import kafaForm from './kafa-form/kafa-form.vue';
Vue.component('KafaForm', kafaForm);
